// Dev-gated logging. Keeps error diagnostics during development but stays silent in
// production builds so debug output is never exposed to end users.
const isDev = process.env.NODE_ENV !== "production";

export const warn = (...args) => {
  if (isDev) console.warn(...args);
};
